import React from 'react';
import { TemplateDefault } from 'src/templates/TemplateDefault';

// import s from './YouAreEnergy.module.scss';

export const YouAreEnergy: React.FC = () => {
  return <TemplateDefault>YouAreEnergy</TemplateDefault>;
};
